import React from "react"
import { Link } from "gatsby"
import * as bread from "./breadcrumbs.module.css"

function Breadcrumbs({ path }) {
  return (
    <div className={bread.wrapper} aria-label={`Page navigation`}>
      {path.map((p, i) => (
        <>
          <Link to={p.link}>
            <p className={bread.link}>{p.title}</p>
          </Link>
          {i < path.length - 1 && <p className={bread.space}>/</p>}
        </>
      ))}
    </div>
  )
}

export default Breadcrumbs
